module.exports = __webpack_public_path__ + "img/45.cd7ef3fb.webp";